import React from "react"
import {Typography} from "@mui/material"

const PriceCategoriesSettingsHelperText = () => {
    return (
        <>
            <Typography variant="subtitle2">
                Alle priser må være knyttet til en <em>priskategori</em>, som igjen er knyttet til
                en <em>varegruppe</em>.
            </Typography>
            <br/>
            <Typography variant="body2">
                Både priskategorier og varegrupper er <em>felles for alle museene i gjeldende konsolidering</em>.
                <br/><br/>
                Grunnen til at faste priskategorier må opprettes i forkant, i stedet for å bare ha et
                fritekstfelt, er at det gjør det enklere å kategorisere besøksstatistikk.
                <br/><br/>
                <em>
                    Vær oppmerksom på at det er fullt mulig å overstyre navnet på priskategoriene, slik
                    at de prisene sluttbruker ser i kjøpsportalen og på billettene, kan skreddersys for
                    hvert enkelt produkt.
                </em>
            </Typography>
        </>
    )
}

export default PriceCategoriesSettingsHelperText